import { TabsContext, TabsProps } from './Tabs';
import React, { useContext } from 'react';

export type TabPanelProps = {
  /**
   * Required tabValue, string compare with selected tab to show panel
   */
  tabValue: TabsProps['value'];
} & React.HTMLAttributes<HTMLDivElement>;

/**
 * @deprecated Deprecated — use pantry Tabs instead.
 * @see https://docs.tocktix.com/pantry?path=/docs/components-tabs--docs
 * Migration: Replace TabPanel with the corresponding sub-component in pantry Tabs.
 */
export const TabPanel = ({ tabValue, children, ...rest }: TabPanelProps) => {
  const tabsContext = useContext(TabsContext);

  const isVisible = tabsContext?.selected === tabValue;

  if (isVisible) {
    return <div {...rest}>{children}</div>;
  }
  return null;
};
